import { fmtNum } from '../utils/fmt';
import { useMemo } from 'react';
import { fmtPct } from '../utils/format';
import InfoTooltip from './InfoTooltip';
import SourceDot, { SourceAttr } from './SourceDot';
import { altszezonIndex, ALTSZEZON_INFO } from '../utils/altseason';


function scoreLabel(score) {
  if (score <= 25) return { text: '⚡ Bitcoin-szezon',  color: '#f5a623' };
  if (score <= 45) return { text: '🔄 Bitcoin felé hajló', color: '#e8c840' };
  if (score <= 55) return { text: '⚖️ Átmeneti zóna', color: '#888'    };
  if (score <= 75) return { text: '🌱 Altok felé hajló',     color: '#69f0ae' };
  return                  { text: '🚀 Altseason!',       color: '#00c853' };
}

export default function AltseasonIndex({ coins, globalData, meta }) {
  // Terminál-javítások 1. kör (A.4): a Terminál fül is ugyanezt a függvényt használja (utils/altseason.js);
  // a BTC-dominancia csak tájékoztató, a pontszámot nem módosítja
  const { score, outperforming, top10alts, btcDom, btc7d } = useMemo(() => {
    const a = altszezonIndex(coins);
    return { score: a.score ?? 0, outperforming: a.beating, top10alts: a.alts, btcDom: globalData?.data?.market_cap_percentage?.btc ?? 0, btc7d: a.btc7d ?? 0 };
  }, [coins, globalData]);

  const lbl = scoreLabel(score);

  return (
    <div className="altseason-widget">

      {/* ── Left: score ── */}
      <div className="alt-score-side">
        <div className="alt-score-num" style={{ color: lbl.color }}>{score}</div>
        <div className="alt-score-tag" style={{ color: lbl.color }}>{lbl.text}<SourceDot source="CoinGecko" meta={meta} /></div>
        <div className="alt-score-sub">
          / 100  Altszezon-index
          <InfoTooltip text={ALTSZEZON_INFO} />
        </div>
      </div>

      {/* ── Center: gradient meter ── */}
      <div className="alt-meter-side">
        <div className="alt-meter-track">
          <div className="alt-meter-dot" style={{ left: `calc(${score}% - 7px)` }} />
        </div>
        <div className="alt-meter-ticks">
          {[0, 25, 50, 75, 100].map(v => (
            <span key={v}>{v}</span>
          ))}
        </div>
        <div className="alt-meter-zone-labels">
          <span style={{ color: '#f5a623' }}>BTC-szezon</span>
          <span style={{ color: '#888' }}>Átmenet</span>
          <span style={{ color: '#00c853' }}>Altszezon</span>
        </div>
      </div>

      {/* ── Right: breakdown ── */}
      <div className="alt-breakdown-side">
        <div className="alt-stat-row">
          <span className="positive" style={{ fontSize: 15, fontWeight: 700 }}>{outperforming}</span>
          <span className="alt-muted">/{top10alts.length} alt teljesít jobban a BTC-nél (7 nap)</span>
        </div>
        <div className="alt-stat-row">
          <span className="alt-muted">BTC 7d</span>
          <span className={btc7d >= 0 ? 'positive' : 'negative'}>&nbsp;{fmtPct(btc7d)}</span>
          <span className="alt-muted">&nbsp;·&nbsp;Dominancia&nbsp;</span>
          <span className="alt-dom-pct">{fmtNum(btcDom, 1)}%</span>
          <InfoTooltip text="BTC dominancia: az összes kriptopénz piaci tőkéjének hány százaléka a Bitcoin. Ha csökken és az 'Egyéb' nő, az altseason közeledtét jelezheti. 40% alatt erős altseason jellemző." />
        </div>
        <div className="alt-badges-row">
          {top10alts.map(c => {
            const c7d   = c.price_change_percentage_7d_in_currency ?? 0;
            const beats = c7d > btc7d;
            return (
              <span
                key={c.id}
                className={`alt-badge ${beats ? 'alt-beat' : 'alt-lag'}`}
                title={`${c.name}: ${fmtPct(c7d)} vs BTC ${fmtPct(btc7d)}`}
              >
                {c.symbol.toUpperCase()}
              </span>
            );
          })}
        </div>
        <SourceAttr cg />
      </div>

    </div>
  );
}
